<app-confirm-dialog></app-confirm-dialog>
<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START navbar header-->
    <div class="navbar-header">
        <a class="navbar-brand" routerLink="/home">
            <div class="brand-logo">
                <img class="img-fluid" src="assets/img/Logo- Horizontal.png" style="margin-top: -20px;"
                    alt="App Logo" />
            </div>
            <div class="brand-logo-collapsed">
                <img class="img-fluid" src="assets/img/180X180-Favicon_With Biometrics.png" alt="App Logo" />

            </div>

        </a>
    </div>
    <!-- END navbar header-->
    <!-- START Left navbar-->
    <ul class="navbar-nav mr-auto flex-row">
        <li class="nav-item">
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a class="nav-link d-none d-md-block d-lg-block d-xl-block" trigger-resize=""
                (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
                <em class="fas fa-bars"></em>
            </a>
            <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
            <a class="nav-link sidebar-toggle d-md-none"
                (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
                <em class="fas fa-bars"></em>
            </a>
        </li>
        <!-- START User avatar toggle-->
        <li class="nav-item d-none d-md-block ">
        </li>
        <!-- END User avatar toggle-->

    </ul>
    <!-- END Left navbar-->

    <!-- START lock screen-->
    <ul class="navbar-nav flex-row">

        <li style="margin-top: 16px;margin-left: 15px;" class="userStart">
            <div style="color: #fff;">Welcome {{firstName | titlecase}}</div>
        </li>

        <!-- START lock screen-->
        <li class="nav-item dropdown dropdown-list d-flex align-items-center" dropdown>
            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle style="cursor: pointer;"
                role="button" aria-haspopup="true" aria-label="Account menu">
                <em class="fas fa-arrow-alt-circle-down"></em>
            </a>
            <!-- START Dropdown menu-->
            <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated fadeIn ps-account-dropdown">
                <a class="dropdown-item" style="cursor: pointer;" (click)="consumerLogout()">
                    <em class="fas fa-user-lock"></em>
                    <span>Logout</span>
                </a>
            </div>
            <!-- END Dropdown menu-->
        </li>
        <!-- END lock screen-->

        <!-- END Offsidebar menu-->
    </ul>
    <!-- END Right Navbar-->

    <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

</nav>
<!-- END Top Navbar-->